import { render, staticRenderFns } from "./R10_rectangle.vue?vue&type=template&id=f6d25b84&scoped=true"
import script from "./R10_rectangle.vue?vue&type=script&lang=js"
export * from "./R10_rectangle.vue?vue&type=script&lang=js"
import style0 from "./R10_rectangle.vue?vue&type=style&index=0&id=f6d25b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d25b84",
  null
  
)

export default component.exports